import { RadioTypes } from "../../commonTypes/universalTypes";
import { twoDigitAfterDecimel } from "../commonFunctions";

export const autoCalculation = (
  itemDataTemp: any[],
  calculationDetails: any,
  setItemDataTemp: any,
  type: string | null
) => {
  //calculation start from line 473 and on top there are function related to it
  let newData = JSON.parse(JSON.stringify(itemDataTemp));
  let gstPercentage = itemDataTemp?.find(
    (item: any) => item?.column_name === "gst_percentage"
  );
  let billFromOrBranch = "";

  if (type === "revenues") {
    billFromOrBranch = calculationDetails?.primaryData?.bill_from?.state;
  }
  if (type === "expenses") {
    billFromOrBranch = calculationDetails?.primaryData?.supplier_name?.state;
  }

  const taxableValueCalculation = () => {
    newData.forEach((e: any) => {
      if (e.column_name === "total_value") {
        return (e["column_value"] = twoDigitAfterDecimel(
          +calculationDetails?.itemDetailsData?.taxable_value
        ));
      }
    });
  };

  const getGstPercentAndAmount = () => {
    let totalValue =
      twoDigitAfterDecimel(+calculationDetails?.itemDetailsData?.amount) +
      (twoDigitAfterDecimel(+calculationDetails?.itemDetailsData?.amount) *
        twoDigitAfterDecimel(+calculationDetails?.itemDetailsData?.gst_percentage)) /
      100;
    newData.forEach((e: any) => {
      if (e.column_name === "total_value") {
        return (e["column_value"] = twoDigitAfterDecimel(+totalValue));
      }
      if (e.column_name === "taxable_value") {
        return (e["column_value"] = twoDigitAfterDecimel(
          +calculationDetails?.itemDetailsData?.amount
        ));
      }
    });
  };

  const igstCgstSgstCalculations = (referenceValue: number) => {
    let igst = 0;
    let cgst = 0;
    let sgst = 0;
    if (!+calculationDetails?.itemDetailsData?.discount && !!gstPercentage?.column_value) {

      if (billFromOrBranch !==
        calculationDetails?.primaryData?.place_of_supply?.value) {
        igst = twoDigitAfterDecimel(
          +((+referenceValue * +gstPercentage?.column_value) / 100)
        );
        cgst = 0;
        sgst = 0;
      }
      else {
        sgst = twoDigitAfterDecimel(
          +((+referenceValue * +gstPercentage?.column_value) / 200)
        );
        cgst = twoDigitAfterDecimel(
          +((+referenceValue * +gstPercentage?.column_value) / 200)
        );
        igst = 0;
      }
    } else if (!!gstPercentage?.column_value) {

      if (billFromOrBranch !==
        calculationDetails?.primaryData?.place_of_supply?.value) {
        igst = twoDigitAfterDecimel(
          +(((+referenceValue -
            +calculationDetails?.itemDetailsData?.discount) * +gstPercentage?.column_value) / 100)
        );
        cgst = 0;
        sgst = 0;
      }
      else {
        sgst = twoDigitAfterDecimel(
          +(
            ((+referenceValue -
              +calculationDetails?.itemDetailsData?.discount) *
              +gstPercentage?.column_value) /
            200
          )
        );
        cgst = twoDigitAfterDecimel(
          +(
            ((+referenceValue -
              +calculationDetails?.itemDetailsData?.discount) *
              +gstPercentage?.column_value) /
            200
          )
        );
        igst = 0;
      }
    }
    return { igst, cgst, sgst }
  }

  const getAmountCalculations = () => {
    let Amount = 0;
    if (!!+calculationDetails?.itemDetailsData?.discount) {
      Amount =
        +calculationDetails?.itemDetailsData?.amount -
        +calculationDetails?.itemDetailsData?.discount;
    } else {
      Amount = +calculationDetails?.itemDetailsData?.amount;
    }

    let sgst = 0;
    let cgst = 0;
    let igst = 0;
    newData.forEach((e: any) => {
      if (e.column_name === "total_value") {
        return (e["column_value"] = twoDigitAfterDecimel(+Amount));
      }
    });

    if (
      calculationDetails &&
      billFromOrBranch &&
      calculationDetails?.primaryData?.place_of_supply?.value
    ) {
      //Inside if state and place_of_supply;
      if (
        billFromOrBranch ==
        calculationDetails?.primaryData?.place_of_supply?.value &&
        calculationDetails?.itemDetailsData?.gst_percentage
      ) {
        sgst = twoDigitAfterDecimel(
          +(
            (+Amount * +calculationDetails?.itemDetailsData?.gst_percentage) /
            200
          )
        );
        cgst = twoDigitAfterDecimel(
          +(
            (+Amount * +calculationDetails?.itemDetailsData?.gst_percentage) /
            200
          )
        );
      } else if (
        billFromOrBranch !==
        calculationDetails?.primaryData?.place_of_supply?.value &&
        calculationDetails?.itemDetailsData?.gst_percentage
      ) {
        igst = twoDigitAfterDecimel(
          +(
            (+Amount * +calculationDetails?.itemDetailsData?.gst_percentage) /
            100
          )
        );
      }
      //Ends if inside state and place_of_supply;
    }

    //In the last
    if (
      !calculationDetails?.itemDetailsData?.rate &&
      !calculationDetails?.itemDetailsData?.quantity
    ) {
      newData.forEach((e: any) => {
        if (e.column_name === "taxable_value") {
          return (e["column_value"] = twoDigitAfterDecimel(+Amount));
        }
        if (!!+calculationDetails?.itemDetailsData?.gst_percentage) {
          //Inside if gst percentage;
          const { igst, cgst, sgst } = igstCgstSgstCalculations(calculationDetails?.itemDetailsData?.amount)
          let totalValue = +Amount + igst + cgst + sgst;
          if (e.column_name === "total_value") {
            return (e["column_value"] = twoDigitAfterDecimel(+totalValue));
          }
          //Ends inside if gst percentage;
        }
        if (e.column_name === "sgst_amount" && sgst != 0) {
          return (e["column_value"] = twoDigitAfterDecimel(+sgst));
        }
        if (e.column_name === "cgst_amount" && cgst != 0) {
          return (e["column_value"] = twoDigitAfterDecimel(+cgst));
        }
        if (e.column_name === "igst_amount" && igst != 0) {
          return (e["column_value"] = twoDigitAfterDecimel(+igst));
        }
      });
    } else if (
      !!+calculationDetails?.itemDetailsData?.rate &&
      !!+calculationDetails?.itemDetailsData?.quantity
    ) {
      const TaxableValueWithSku =
        +calculationDetails?.itemDetailsData?.rate *
        +calculationDetails?.itemDetailsData?.quantity
      const { igst, cgst, sgst } = igstCgstSgstCalculations(TaxableValueWithSku)
      newData.forEach((e: any) => {
        if (e.column_name === "total_value") {
          return e["column_value"] = twoDigitAfterDecimel((+TaxableValueWithSku - (!!calculationDetails?.itemDetailsData?.discount && calculationDetails?.itemDetailsData?.discount > 0
            ? +calculationDetails?.itemDetailsData?.discount
            : 0)) + igst + cgst + sgst)
        }
      });
    }
  };

  const getTaxableValueAndGstPercentageCalculation = () => {
    let { igst, cgst, sgst } = igstCgstSgstCalculations(calculationDetails?.itemDetailsData?.taxable_value)
    newData.forEach((e: any) => {
      if (e.column_name === "total_value") {
        return (e["column_value"] = twoDigitAfterDecimel(
          +calculationDetails?.itemDetailsData?.taxable_value + igst + cgst + sgst
        ));
      }
    });

    if (
      calculationDetails &&
      billFromOrBranch &&
      !!calculationDetails?.primaryData?.place_of_supply?.value
    ) {
      newData.forEach((e: any) => {
        if (e.column_name === "sgst_amount" && sgst != 0) {
          return (e["column_value"] = twoDigitAfterDecimel(+sgst));
        }
        if (e.column_name === "cgst_amount" && cgst != 0) {
          return (e["column_value"] = twoDigitAfterDecimel(+cgst));
        }
        if (e.column_name === "igst_amount" && igst != 0) {
          return (e["column_value"] = twoDigitAfterDecimel(+igst));
        }
      });
    }
  };

  const getSkuRateAndQuantityCalculation = () => {
    let TaxableValueWithSku =
      +calculationDetails?.itemDetailsData?.rate *
      +calculationDetails?.itemDetailsData?.quantity;
    newData.forEach((e: any) => {
      if (e.column_name === "taxable_value") {
        return (e["column_value"] = twoDigitAfterDecimel(+TaxableValueWithSku));
      }
      if (e.column_name === "total_value") {
        return (e["column_value"] = twoDigitAfterDecimel(+TaxableValueWithSku));
      }
      if (e.column_name === "amount") {
        return (e["column_value"] = twoDigitAfterDecimel(+TaxableValueWithSku));
      }
    });

    if (
      !!+gstPercentage?.column_value ||
      !!+calculationDetails?.itemDetailsData?.discount
    ) {
      //inside when gst %
      newData.forEach((e: any) => {
        if (!!+gstPercentage?.column_value) {
          if (e.column_name === "total_value") {
            let { igst, cgst, sgst } = igstCgstSgstCalculations(TaxableValueWithSku)

            return (e["column_value"] = twoDigitAfterDecimel(
              +(
                +TaxableValueWithSku + cgst + igst + sgst

              )
            ));
          }
        } else if (!!+calculationDetails?.itemDetailsData?.discount) {
          if (e.column_name === "total_value") {
            return (e["column_value"] = twoDigitAfterDecimel(
              +(
                +TaxableValueWithSku -
                +calculationDetails?.itemDetailsData?.discount
              )
            ));
          }
        }
      });
    }

    if (
      calculationDetails?.itemDetailsData?.sku_code?.value &&
      !!calculationDetails?.itemDetailsData?.rate &&
      !!calculationDetails?.itemDetailsData?.quantity
    ) {
      // inside if sku_code && rate && quantity ;
      if (
        calculationDetails &&
        billFromOrBranch &&
        calculationDetails?.primaryData?.place_of_supply?.value &&
        !!+gstPercentage?.column_value
      ) {

        //inside if bill from and place of supply and gst percent.
        if (
          billFromOrBranch ==
          calculationDetails?.primaryData?.place_of_supply?.value &&
          !!+gstPercentage?.column_value
        ) {
          let { igst, cgst, sgst } = igstCgstSgstCalculations(TaxableValueWithSku)

          newData.forEach((e: any) => {
            if (e.column_name === "taxable_value") {
              return (e["column_value"] = twoDigitAfterDecimel(
                +TaxableValueWithSku -
                +calculationDetails?.itemDetailsData?.discount
              ));
            }
            if (e.column_name === "sgst_amount" && sgst != 0) {
              return (e["column_value"] = twoDigitAfterDecimel(+sgst));
            }
            if (e.column_name === "cgst_amount" && cgst != 0) {
              return (e["column_value"] = twoDigitAfterDecimel(+cgst));
            }
          });
        } else if (
          billFromOrBranch !==
          calculationDetails?.primaryData?.place_of_supply?.value &&
          !!+gstPercentage?.column_value
        ) {
          let { igst } = igstCgstSgstCalculations(TaxableValueWithSku)

          newData.forEach((e: any) => {
            if (e.column_name === "igst_amount" && igst != 0) {
              return (e["column_value"] = twoDigitAfterDecimel(+igst));
            }
          });
        }
      }

      newData.forEach((e: any) => {
        if (
          e.column_name === "taxable_value" &&
          +calculationDetails?.itemDetailsData?.discount
        ) {
          return (e["column_value"] = twoDigitAfterDecimel(
            +TaxableValueWithSku -
            +calculationDetails?.itemDetailsData?.discount
          ));
        }
        if (e.column_name === "taxable_value") {
          return (e["column_value"] = twoDigitAfterDecimel(
            +TaxableValueWithSku
          ));
        }
        if (
          e.column_name === "total_value" &&
          (+gstPercentage?.column_value ||
            +calculationDetails?.itemDetailsData?.discount)
        ) {
          if (
            e.column_name === "total_value" &&
            +gstPercentage?.column_value &&
            +calculationDetails?.itemDetailsData?.discount
          ) {
            let { igst, cgst, sgst } = igstCgstSgstCalculations(TaxableValueWithSku)
            return e["column_value"] = twoDigitAfterDecimel((TaxableValueWithSku - +calculationDetails?.itemDetailsData?.discount) + igst + cgst + sgst)
          } else if (
            e.column_name === "total_value" &&
            +calculationDetails?.itemDetailsData?.discount
          ) {
            return (e["column_value"] = twoDigitAfterDecimel(
              +TaxableValueWithSku -
              +calculationDetails?.itemDetailsData?.discount
            ));
          }
        }
      });
    }
  };

  const resetBasedOnSkuRateQty = () => {
    newData.forEach((e: any) => {
      if (e.column_name === "total_value") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "sgst_amount") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "cgst_amount") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "igst_amount") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "taxable_value") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "gst_percentage") {
        // resetCalculationDetails(e["column_value"])
        return (e["column_value"] = "");
      }
      if (e.column_name === "discount") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "amount") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "quantity") {
        return (e["column_value"] = "");
      }
    });
  };

  const resetBasedOnGstPercentage = () => {
    newData.forEach((e: any) => {
      if (e.column_name === "sgst_amount") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "cgst_amount") {
        return (e["column_value"] = "");
      }
      if (e.column_name === "igst_amount") {
        return (e["column_value"] = "");
      }
    });
  };

  //Calculation starts from here
  if (calculationDetails) {
    //inside if taxable value
    if (calculationDetails?.itemDetailsData?.taxable_value) {
      taxableValueCalculation();
    }

    //if sku && not of rate and not of quantity
    if (
      !!calculationDetails?.itemDetailsData?.sku_code?.value &&
      !+calculationDetails?.itemDetailsData?.rate &&
      !+calculationDetails?.itemDetailsData?.quantity
    ) {
      resetBasedOnSkuRateQty();
    }

    // if sku && not of rate
    if (
      !!calculationDetails?.itemDetailsData?.sku_code?.value &&
      !+calculationDetails?.itemDetailsData?.rate
    ) {
      resetBasedOnSkuRateQty();
    }

    //if not of gst percentage
    if (!calculationDetails?.itemDetailsData?.gst_percentage) {
      resetBasedOnGstPercentage();
    }

    //Inside if taxable Value And Percentage
    if (
      !!calculationDetails?.itemDetailsData?.taxable_value &&
      !!calculationDetails?.itemDetailsData?.gst_percentage
    ) {
      getTaxableValueAndGstPercentageCalculation();
    }

    //Inside if gst percentage and amount
    if (
      !!+calculationDetails?.itemDetailsData?.gst_percentage &&
      !!+calculationDetails?.itemDetailsData?.amount
    ) {
      getGstPercentAndAmount();
    }

    //inside if sku_code && rate && quantity;
    if (
      calculationDetails?.itemDetailsData?.sku_code?.value &&
      !!+calculationDetails?.itemDetailsData?.rate &&
      !!+calculationDetails?.itemDetailsData?.quantity
    ) {
      getSkuRateAndQuantityCalculation();
    }

    if (!!+calculationDetails?.itemDetailsData?.amount) {
      getAmountCalculations();
    }

    setItemDataTemp(newData);
  }
};

export const resettingGstOnEdit = (
  calculationDetails: any,
  updateItem: any,
  type: string | null
) => {
  let billFromOrBranch;

  if (type === "revenues") {
    billFromOrBranch = calculationDetails?.primaryData?.bill_from?.state;
  }
  if (type === "expenses") {
    billFromOrBranch = calculationDetails?.primaryData?.supplier_name?.state;
  }

  if (
    billFromOrBranch &&
    calculationDetails?.primaryData?.place_of_supply?.value
  ) {
    if (
      billFromOrBranch ==
      calculationDetails?.primaryData?.place_of_supply?.value
    ) {
      updateItem?.forEach((item: any) => {
        if (item.column_name === "igst_amount") {
          item.column_value = "";
        }
      });
    } else {
      updateItem?.forEach((item: any) => {
        if (item.column_name === "sgst_amount") {
          item.column_value = "";
        }
        if (item.column_name === "cgst_amount") {
          item.column_value = "";
        }
      });
    }
  }
};

export const settingApproval = (
  approvalData: string | undefined,
  setApproval: any
) => {
  setApproval(approvalData);
};

export const settingAttachment = (
  attachmentData: string | undefined,
  setAttachment: any
) => {
  setAttachment(attachmentData);
};

export const settingComment = (
  commentData: string | undefined,
  setComment: any
) => {
  setComment(commentData)
}

export const addShippingAddress = (primary: any) => {
  let primaryArray = JSON.parse(JSON.stringify(primary));

  let shippingArray: any = [];

  primaryArray.map((e: any, i: number) => {
    if (e?.column_name === "ship_to_name") {
      shippingArray.push(e);
    }
    if (e?.column_name === "ship_to_address") {
      shippingArray.push(e);
    }
    if (e?.column_name === "ship_to_gst") {
      shippingArray.push(e);
    }
  });

  return shippingArray;
};

export const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "0",
    name: "Yes",
  },
  {
    id: "1",
    name: "No",
  },
];

export const resetShippingAddressData = (
  primaryData: any,
  shippingAddressColumns: any,
  setPrimaryData: any,
  setShippingAddressColumns: any
) => {
  let newData = JSON.parse(JSON.stringify(primaryData));
  let shippingData = JSON.parse(JSON.stringify(shippingAddressColumns));

  shippingData?.map((item: any) => {
    if (item.column_name === "ship_to_name") {
      item.column_value = "";
    }
    if (item.column_name === "ship_to_address") {
      item.column_value = "";
    }
    if (item.column_name === "ship_to_gst") {
      item.column_value = "";
    }
  });

  newData?.map((item: any) => {
    if (item.column_name === "ship_to_name") {
      item.column_value = "";
    }

    if (item.column_name === "ship_to_address") {
      item.column_value = "";
    }
    if (item.column_name === "ship_to_gst") {
      item.column_value = "";
    }
  });

  setShippingAddressColumns(shippingData);
  setPrimaryData(newData);
};
